import { useCommon } from "../composition-functions/common";
import { mapSmartpricingSettingsDtoToSmartpricingSettingsInputDto, SmartpricingSettingsDto } from "./dto.smartpricingSettings";

export async function getSmartpricingSettings(mandantId: number): Promise<SmartpricingSettingsDto> {
  const { getRequest } = useCommon();
  const response = await getRequest({ path: `/admin/mandants/${mandantId}/smartpricing/settings/` });
  return await response.json();
}

interface SetSmartpricingSettingsParams {
  mandantId: number;
  smartpricingSettingsDto: SmartpricingSettingsDto;
}
export async function setSmartpricingSettings({
  mandantId,
  smartpricingSettingsDto,
}: SetSmartpricingSettingsParams): Promise<SmartpricingSettingsDto> {
  const { postRequest } = useCommon();
  const response = await postRequest({
    path: `/admin/mandants/${mandantId}/smartpricing/settings/`,
    data: JSON.stringify(mapSmartpricingSettingsDtoToSmartpricingSettingsInputDto(smartpricingSettingsDto)),
  });
  return await response.json();
}
